<template>
  <el-form ref="form" :model="curInput" :rules="rules" label-width="100px">
    <!-- <el-form-item label="是否具有搜索功能" prop="has_search">
      <el-radio-group v-model="curInput.select.has_search">
        <el-radio :label="1">是</el-radio>
        <el-radio :label="0">否</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="是否显示空值选项" prop="empty_status">
      <el-radio-group v-model="curInput.select.empty_status" @change="resetEmptyValue">
        <el-radio :label="1">是</el-radio>
        <el-radio :label="0">否</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="选项空值选项内容" v-show="curInput.select.empty_status == 1">
      <el-input v-model.trim="curInput.select.empty_value" placeholder="选项值" class="h-40 w-100"></el-input>
    </el-form-item> -->
    <option-config :curInput="curInput" :selectConfig="curInput.select_option"></option-config>
  </el-form>
</template>

<script>
  import optionConfig from './optionConfig'
  export default {
    props: ['curInput'],
    data() {
      return {
      }
    },
    components: {
      optionConfig
    },
    methods: {
      // resetEmptyValue() {
      //   if (this.curInput.select.empty_status == 0) {
      //     this.curInput.select.empty_value = ''
      //   }
      // }
    }
  }
</script>


// WEBPACK FOOTER //
// selectConfig.vue?0814750e